import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgArea(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="4 -4 16 24" {...props}>
      <path
        d="M17 0a2 2 0 011.235 3.573l.51 3.57a2 2 0 01-1.262 3.79l-2.55 2.55A2.003 2.003 0 0113 16a2 2 0 01-1.94-1.514l-3.67-1.049a2 2 0 11-2.214-3.26l.656-6.553A2 2 0 118.732 1h6.536A2 2 0 0117 0zm-4 13a1 1 0 100 2 1 1 0 000-2zm-7-2a1 1 0 100 2 1 1 0 000-2zm9.268-7.999H8.732c-.209.36-.527.65-.91.823l-.654 6.552c.378.272.656.673.773 1.138l3.668 1.049a1.993 1.993 0 011.908-.496l2.55-2.55a2.003 2.003 0 01.698-2.09l-.511-3.57A2.007 2.007 0 0115.268 3zM18 8a1 1 0 100 2 1 1 0 000-2zm-1-7a1 1 0 100 2 1 1 0 000-2zM7 1a1 1 0 100 2 1 1 0 000-2z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('Area')(SvgArea);
